/**
 * Drvetion theme interactions.
 *
 * Event delegation is intentional: Concept can replace mega-menu content
 * through Shopify's Section Rendering API after the initial page load.
 */
(function () {
  function enhanceSliderProgress(scope) {
    var root = scope || document;
    var sliders = Array.from(root.querySelectorAll('slider-element[id]'));

    sliders.forEach(function (slider) {
      if (slider.dataset.drvProgressChecked === 'true') return;
      slider.dataset.drvProgressChecked = 'true';

      var sliderId = slider.id;
      if (!sliderId || sliderId.indexOf('SliderGallery') !== -1) return;

      var controlledButtons = Array.from(
        document.querySelectorAll('[aria-controls="' + sliderId + '"]')
      );
      var previous = controlledButtons.find(function (button) {
        return button.matches('[is="previous-button"]');
      });
      var next = controlledButtons.find(function (button) {
        return button.matches('[is="next-button"]');
      });

      if (!previous || !next || previous.parentElement !== next.parentElement) return;

      var arrowGroup = previous.parentElement;
      var controls = arrowGroup.closest('.drv-slider-controls') || arrowGroup;
      if (controls.querySelector('.drv-slider-progress')) return;

      var selector = slider.getAttribute('selector');
      var items = selector
        ? Array.from(slider.querySelectorAll(selector))
        : Array.from(slider.children);

      if (items.length < 2) return;

      controls.classList.add('drv-slider-controls');

      if (controls === arrowGroup) {
        var wrappedArrows = document.createElement('div');
        wrappedArrows.className = 'drv-slider-controls__arrows';
        controls.insertBefore(wrappedArrows, previous);
        wrappedArrows.appendChild(previous);
        wrappedArrows.appendChild(next);
        arrowGroup = wrappedArrows;
      } else {
        arrowGroup.classList.add('drv-slider-controls__arrows');
      }

      var progress = document.createElement('slider-dots');
      progress.className = 'drv-slider-progress';
      progress.setAttribute('aria-controls', sliderId);

      items.forEach(function (_item, index) {
        var dot = document.createElement('button');
        var label = document.createElement('span');

        dot.type = 'button';
        dot.dataset.index = String(index + 1);
        if (index === 0) dot.setAttribute('aria-current', 'true');

        label.className = 'sr-only';
        label.textContent = 'Show slide ' + String(index + 1);
        dot.appendChild(label);
        progress.appendChild(dot);
      });

      controls.insertBefore(progress, arrowGroup);
    });
  }

  function selectMegaTab(tab, moveFocus) {
    var menu = tab.closest('[data-drv-header-mega]');
    if (!menu) return;

    var tabs = Array.from(menu.querySelectorAll('[data-drv-mega-tab]'));
    var panels = Array.from(menu.querySelectorAll('[data-drv-mega-panel]'));
    var index = tabs.indexOf(tab);

    if (index < 0 || tabs.length !== panels.length) return;

    tabs.forEach(function (item, itemIndex) {
      var selected = itemIndex === index;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });

    panels.forEach(function (panel, panelIndex) {
      panel.hidden = panelIndex !== index;
    });

    if (moveFocus) tab.focus();
  }

  function syncDrawerSummaries(scope) {
    var root = scope || document;
    var drawer = root.matches && root.matches('#MenuDrawer')
      ? root
      : root.querySelector && root.querySelector('#MenuDrawer');

    if (!drawer) return;

    Array.from(drawer.querySelectorAll('summary[data-drv-drawer-summary]')).forEach(function (summary) {
      var details = summary.closest('details');
      summary.setAttribute('aria-expanded', String(Boolean(details && details.hasAttribute('open'))));
    });

    if (drawer.dataset.drvAriaObserved === 'true') return;
    drawer.dataset.drvAriaObserved = 'true';

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type !== 'attributes' || record.attributeName !== 'open') return;
        var summary = record.target.querySelector(':scope > summary[data-drv-drawer-summary]');
        if (summary) {
          summary.setAttribute('aria-expanded', String(record.target.hasAttribute('open')));
        }
      });
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true
    });
  }

  function handleHeaderKeyboard(event) {
    var summary = event.target.closest('.header__menu > ul > li > details > summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      details.open = !details.open;
    } else if (event.key === 'Escape' && details.open) {
      event.preventDefault();
      details.open = false;
      summary.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-drv-mega-tab]');
    if (!tab) return;

    event.preventDefault();
    selectMegaTab(tab, false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-drv-mega-tab]');
    if (!tab) return;

    var tabs = Array.from(
      tab.closest('[data-drv-header-mega]').querySelectorAll('[data-drv-mega-tab]')
    );
    var index = tabs.indexOf(tab);
    var nextIndex = index;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = (index + 1) % tabs.length;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = (index - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    selectMegaTab(tabs[nextIndex], true);
  });

  document.addEventListener('keydown', handleHeaderKeyboard, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceSliderProgress(document);
      syncDrawerSummaries(document);
    });
  } else {
    enhanceSliderProgress(document);
    syncDrawerSummaries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceSliderProgress(event.target);
    syncDrawerSummaries(event.target);
  });
})();
